/* unplugin-vue-components disabled */import { render } from "./CubeComplementRender.vue?vue&type=template&id=c99ab7ea&scoped=true"
import script from "./CubeComplementRender.vue?vue&type=script&lang=js"
export * from "./CubeComplementRender.vue?vue&type=script&lang=js"

import "./CubeComplementRender.vue?vue&type=style&index=0&id=c99ab7ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c99ab7ea"]])

export default __exports__